import { useRef, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';

// get the previous props or state
export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => ref.current = value);
  return ref.current;
}

// go back to a proper page when needed (e.g. after edit job)
export function useGoBack(fallback) {
  const navigate = useNavigate();
  const location = useLocation();
  let url;
  if (location.key !== 'default') {
    // go back one step in the history stack
    url = -1;
  } else if (document.referrer.includes(window.location.host)) {
    // navigate does not support full url
    // https://github.com/remix-run/react-router/discussions/11667
    url = document.referrer.slice((window.location.protocol + '//' + window.location.host).length);
  } else {
    url = fallback;
  }
  return () => navigate(url);
}
